// Router state selectors.
// redux-first-router doesn't seem to supply it's own. If it does, switch to those.

export const routeSelector = state => state.location.type;
export const routeParamsSelector = state => state.location.payload;



// WEBPACK FOOTER //
// ./src/ducks/routeSelectors.js